/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MedicalAssistanceType {
    PRIMARY_MEDICAL_CARE = 'primaryMedicalCare',
    HOSPITAL_MEDICAL_CARE = 'hospitalMedicalCare',
    EMERGENCY_MEDICAL_CARE = 'emergencyMedicalCare',
    CONSULTATIVE_MEDICAL_CARE = 'consultativeMedicalCare',
    LABORATORY = 'laboratory',
    OTHERS = 'others',
    PENITENTIARY = 'penitentiary',
}
